<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <add-co-logo />
      <h2 class="brand-text text-primary ml-1">
        AddCo
      </h2>
    </b-link>

    <!-- Loading -->
    <loading
      v-if="isLoading"
      :active="true" 
      :is-full-page="true"
      color="#498ceb"
    />

    <div v-if="!isLoading" class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 :class="presenceValidated ? 'text-success' : 'text-danger'">
          {{ presenceValidated ? $t('message.presence_validated') : $t('message.presence_not_validated') }}
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton } from 'bootstrap-vue'
import AddCoLogo from '@core/layouts/components/Logo.vue'
import { ref, onMounted } from "@vue/composition-api";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import useNotifications from "@/composables/useNotifications";
import { useRouter } from '@core/utils/utils'
import i18n from '@/libs/i18n'
import useJwt from '@/auth/jwt/useJwt'
import realmConnection from '@/views/habit/realm'

export default {
  components: {
    AddCoLogo,
    BLink,
    BButton,
    Loading,
  },
  setup() {
    const { showSuccessMessage, showErrorMessage } = useNotifications();
    const { route } = useRouter()
    const { updateItem, ObjectId } = realmConnection()
    const presenceValidated = ref(false)
    const isLoading = ref(true)

    onMounted(async () => {
      // Define locale based on the language of the browser UI
      if (window.navigator.language?.startsWith('es')) i18n.locale = 'es'

      try {
        // If user is not logged in (either as a real or anonymous user), then log in as an anonymous user
        if (!useJwt.realm.currentUser) await useJwt.loginAsAnonymousUser()

        // Update presence validation in database with validated: true
        const query = { _id: ObjectId(route.value.params.presenceValidationId) }
        const payload = { validated: true }
        const action = { $set: payload }
        
        const { modifiedCount } = await updateItem({ collection: 'presence_validation', query, action })

        presenceValidated.value = modifiedCount ? true : false
      } catch (error) {
        console.log(error)
        showErrorMessage(i18n.t('message.err_validate_presence'))
      } finally {
        isLoading.value = false
      }
    })

    return {
      presenceValidated,
      isLoading,
    };
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>